import { render, staticRenderFns } from "./Acquisitions.vue?vue&type=template&id=78ed4038&scoped=true&"
import script from "./Acquisitions.vue?vue&type=script&lang=js&"
export * from "./Acquisitions.vue?vue&type=script&lang=js&"
import style0 from "./Acquisitions.vue?vue&type=style&index=0&id=78ed4038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed4038",
  null
  
)

export default component.exports